import React, { createContext, useState, useContext } from "react";

type TutorialsContextType = {
    disabled: boolean;
    setDisabled: React.Dispatch<React.SetStateAction<boolean>>;
};

const TutorialsContext = createContext<TutorialsContextType | undefined>(undefined);

export const TutorialsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [disabled, setDisabled] = useState(false);

    return (
        <TutorialsContext.Provider value={{ disabled, setDisabled }}>
            {children}
        </TutorialsContext.Provider>
    );
};

export const useTutorialsContext = (): TutorialsContextType => {
    const context = useContext(TutorialsContext);
    if (!context) {
        throw new Error("useTutorialsContext must be used within a TutorialsProvider");
    }
    return context;
};